import React from 'react';
import { ResponsiveBar } from '@nivo/bar'

export default function BarGraph({data}) {

  /*const data = [
    {
      "mesAno": "04/2020",
      "previsao": 44,
      "faturado": 40,
    },
    {
      "mesAno": "03/2020",
      "previsao": 120,
      "faturado": 16,
    },
    {
      "mesAno": "02/2020",
      "previsao": 194,
      "faturado": 141,
    }
  ];*/

return(
    <ResponsiveBar
        data={data}
        keys={[ 'previsao', 'faturado' ]}
        indexBy="mesAno"
        margin={{ top: 0, right: 130, bottom: 50, left: 60 }}
        padding={0.3}
        groupMode="grouped"
        colors={{ scheme: 'nivo' }}
        borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Mês/Ano',
            legendPosition: 'middle',
            legendOffset: 32
        }}
        axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'R$',
            legendPosition: 'middle',
            legendOffset: -40
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
        legends={[
            {
                dataFrom: 'keys',
                anchor: 'bottom-right',
                direction: 'column',
                justify: false,
                translateX: 120,
                translateY: 0,
                itemsSpacing: 2,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: 'left-to-right',
                itemOpacity: 0.85,
                symbolSize: 20,
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ]}
        animate={true}
        motionStiffness={90}
        motionDamping={15}
    />
)};